module.exports = {
  // At least WCAG AA Normal Text against #ffffff
  // amber
  0: '#A7230C',
  // sky blue
  1: '#105BB2',
  // moss
  2: '#197B7B',
  // lilac
  3: '#BF00E0',
  // gold
  4: '#9E6400',
  // salmon
  5: '#BD0023',
  // purple
  6: '#2929FF',
  // peach
  7: '#EB1400',
  // baby blue
  8: '#11799C',
  // lime
  9: '#105102',
  //  magenta
  10: '#750044',
};
